export default __webpack_public_path__ + "static/media/tmp_fincar_image02.eecec5bf.png";